module.exports = __webpack_public_path__ + "icon-left/icon-left-56952b99a62bd1681febcecb9e6866dd.svg";